import posthog from 'posthog-js'
import { Environment, getEnvironment } from '../config'

type AnalyticsData = { [key: string]: string | number | boolean | undefined | null }

export const trackEvent = (event: string, data?: AnalyticsData) => {
  // Avoid tracking events in development
  if (getEnvironment() === Environment.PRODUCTION || getEnvironment() === Environment.STAGING) {
    posthog.capture(event, data)
  }
}

export const trackingToken = (): string => {
  //From posthog.com
  //You can use this write-only key in any one of our libraries.
  //Write-only means it can only create new events. It can't read events or any of your other data stored with PostHog
  //So it's safe to use in public apps.

  if (getEnvironment() === Environment.PRODUCTION) return 'phc_76JazgpUJbhvxPWTQYWhyrELEYPoBhDcbw8Yg6jwhbw'
  if (getEnvironment() === Environment.STAGING) return 'phc_hw9MmS4t8zDSe7HGcpuU7JScRUV75tGirmB83E7zads'
  return 'UNKNOWN'
}
